import apiClient from "@/app/api/client";
import type { NotificationChannelsMap, TelegramBotTokenStatus } from "../types";

interface SettingResponse {
	success: true;
	data: { key: string; value: unknown; updatedAt: string | null };
}

interface TelegramBotTokenStatusResponse {
	success: true;
	data: TelegramBotTokenStatus;
}

export const notificationsService = {
	/** `POST /notifications/{id}/read` — javob 204, tanasi yo'q. */
	async markRead(id: string): Promise<void> {
		await apiClient.post(`/notifications/${id}/read`);
	},

	/**
	 * Kanal sozlamasi — oddiy `settings` kaliti. Alohida endpoint ATAYLAB
	 * yaratilmadi: ikkinchi yozuvchi sozlamaning yagona haqiqat manbaini
	 * ikkiga bo'lardi.
	 */
	async saveChannels(value: NotificationChannelsMap): Promise<void> {
		await apiClient.patch<SettingResponse>("/settings/notification_channels", { value });
	},

	/** Bot TOKEN — generic `/settings/{key}` DAN ALOHIDA: javob xom qiymatni hech qachon qaytarmaydi. */
	async getTelegramBotTokenStatus(): Promise<TelegramBotTokenStatus> {
		const response = await apiClient.get<TelegramBotTokenStatusResponse>(
			"/settings/telegram-bot-token"
		);
		return response.data.data;
	},

	async rotateTelegramBotToken(token: string): Promise<TelegramBotTokenStatus> {
		const response = await apiClient.put<TelegramBotTokenStatusResponse>(
			"/settings/telegram-bot-token",
			{ token }
		);
		return response.data.data;
	},
};
